import { render, staticRenderFns } from "./ChangeDetails.vue?vue&type=template&id=66817c76"
import script from "./ChangeDetails.vue?vue&type=script&lang=js"
export * from "./ChangeDetails.vue?vue&type=script&lang=js"
import style0 from "./ChangeDetails.vue?vue&type=style&index=0&id=66817c76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports